import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    tags: [],
    subscribers: [],
    lists: [],
    segmentation: [],
    curSegmentDetails: [],
    saveOrUpdate: null
};

const mlrSlice = createSlice({
    name: "pkzmlr",
    initialState,
    reducers: {
        fillTags(state, action) {
            state.tags = action.payload;
        },
        fillSubscribers(state, action) {
            state.subscribers = action.payload;
        },
        fillLists(state, action) {
            state.lists = action.payload;
        },
        fillSegmentation(state, action) {
            state.segmentation = action.payload;
        },
        currentSegmentDetails(state, action) {
            state.curSegmentDetails = action.payload;
        },
        currentDBOperation(state, action) {
            state.saveOrUpdate = action.payload;
        }
    }
});

export const { fillTags, fillSubscribers, fillLists, fillSegmentation, currentSegmentDetails, currentDBOperation } = mlrSlice.actions;
export default mlrSlice.reducer;